import { WarningModal } from "./WarningModal";

export const ConfirmRecipeModal = ({
  selectedRecipeId,
  showRecipeConfirmModal,
  handleConfirmRecipeModal,
}: {
  selectedRecipeId: number | null;
  showRecipeConfirmModal: boolean;
  handleConfirmRecipeModal: (selectedRecipeId: number | null) => void;
}) => {
  return (
    <WarningModal
      open={showRecipeConfirmModal}
      title="Confirmation"
      message="Updating the recipe will automatically reset the details of the current layers: commodities and weights will be replaced by those from the new recipe. Do you want to continue?"
      onCancel={() => handleConfirmRecipeModal(null)}
      onProceed={() => handleConfirmRecipeModal(selectedRecipeId)}
      cancelText="CANCEL"
      proceedText="PROCEED"
    />
  );
};
